

































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import { ConfigurationAnswer } from '@/models/configurator/configuration';

// Utilities
import { timeAgo } from '@/utils/timeAgo';
import { Question } from '@/models/configurator/question';

export default Vue.extend({
  props: {
    value: {
      type: [Object, Array, Number, String]
    }
  },
  data: () => ({
    headers: [
      {
        text: '#',
        align: 'center',
        sortable: false,
        value: 'index'
      },
      {
        text: 'Question',
        sortable: false,
        value: 'question'
      },
      {
        text: 'Answer',
        sortable: false,
        value: 'answer'
      }
    ],
    loading: false
  }),

  computed: {
    answers: get<ConfigurationAnswer[]>('configuratorConfiguration/answers'),

    getQuestionById: get<(module: number, id: number) => Question>(
      'configuratorQuestion/getQuestionById'
    ),

    internalValue: {
      get(): any {
        return this.value;
      },
      set(value: any) {
        this.$emit('input', value);
      }
    }
  },

  mounted() {
    this.loading = true;
    this.fetchConfigurationAnswers(this.$route.params.configurationId)
      .then(() => {
        if (this.answers.length) {
          this.fetchQuestions({
            module: this.answers[0].module,
            configuration: this.answers[0].configuration
          });
        }
      })
      .finally(() => (this.loading = false));
  },

  methods: {
    ...mapActions('configuratorConfiguration', ['fetchConfigurationAnswers']),
    ...mapActions('configuratorQuestion', ['fetchQuestion', 'fetchQuestions']),

    timeAgo,

    getAnswerText(item: any) {
      if (item.value) {
        return `${item.value}`;
      } else if (item.choice) {
        return `${item.choice}`;
      }
    }
  }
});
